import { useCallback } from 'react';

import { useSelector } from 'third-party';

import { appSelectors } from 'selectors';

import { APIUserType } from 'types/api';

export const useUserTypeIn = () => {
  const userType = useSelector(appSelectors.userType);

  return useCallback(
    (userTypes: APIUserType | APIUserType[]) =>
      !!userType &&
      (Array.isArray(userTypes) ? userTypes : [userTypes]).includes(userType),

    [userType],
  );
};
